/* unplugin-vue-components disabled */import { render } from "./BlanksInput.vue?vue&type=template&id=796f3588&scoped=true&ts=true"
import script from "./BlanksInput.vue?vue&type=script&lang=ts"
export * from "./BlanksInput.vue?vue&type=script&lang=ts"

import "./BlanksInput.vue?vue&type=style&index=0&id=796f3588&lang=scss&scoped=true"
import "./BlanksInput.vue?vue&type=style&index=1&id=796f3588&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-796f3588"]])

export default __exports__